'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var definitions = require('./definitions-0c162dc8.js');
var lib = require('./lib-26f8f706.js');
require('tslib');



Object.defineProperty(exports, 'AngleUnit', {
	enumerable: true,
	get: function () { return definitions.AngleUnit; }
});
Object.defineProperty(exports, 'Axis', {
	enumerable: true,
	get: function () { return definitions.Axis; }
});
Object.defineProperty(exports, 'Delay', {
	enumerable: true,
	get: function () { return definitions.Delay; }
});
Object.defineProperty(exports, 'Direction', {
	enumerable: true,
	get: function () { return definitions.Direction; }
});
Object.defineProperty(exports, 'LengthUnit', {
	enumerable: true,
	get: function () { return definitions.LengthUnit; }
});
Object.defineProperty(exports, 'Speed', {
	enumerable: true,
	get: function () { return definitions.Speed; }
});
exports.delayToDurationMs = definitions.delayToDurationMs;
exports.speedToDurationMs = definitions.speedToDurationMs;
exports.variant = lib.variant;
//# sourceMappingURL=index.js.map
